import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { PerformancePeriod } from "../../../../../../../../../features/optifundDashboardSlice";

interface PerformancePeriodFilterProps {
  period: PerformancePeriod;
  onPeriodChange: (period: PerformancePeriod) => void;
}

// Mobile's replacement for the desktop Account Summary table's period
// ToggleButtonGroup (embedded inside PerformanceTable.tsx) - same three
// values, standalone here since the mobile table below has no other
// controls (Story 7: Performance keeps only the period selector, no date
// filter).
export default function PerformancePeriodFilter({ period, onPeriodChange }: PerformancePeriodFilterProps) {
  return (
    <ToggleButtonGroup
      value={period}
      exclusive
      fullWidth
      color="secondary"
      size="small"
      onChange={(_event, value: PerformancePeriod | null) => value && onPeriodChange(value)}
    >
      <ToggleButton value="daily">Daily</ToggleButton>
      <ToggleButton value="weekly">Weekly</ToggleButton>
      <ToggleButton value="monthly">Monthly</ToggleButton>
    </ToggleButtonGroup>
  );
}
